import React from "react";
import { Navigate } from "react-router-dom";
import { isAuthenticated, getRole } from "../auth";

const PrivateRoute = ({ element, adminOnly = false }) => {
    // ️ Nije ulogovan
    if (!isAuthenticated()) {
        return <Navigate to="/login" replace />;
    }

    //  Ruta je samo za admina
    if (adminOnly) {
        const role = getRole();

        const isAdmin =
            role === "ROLE_ADMIN" ||
            (Array.isArray(role) && role.includes("ROLE_ADMIN"));

        if (!isAdmin) {
            return <Navigate to="/profile" replace />;
        }
    }

    // Sve OK -> prikaži komponentu
    return element;
};

export default PrivateRoute;
